var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/embedded-status/index.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchStatus } from 'soapbox/actions/statuses';
import MissingIndicator from 'soapbox/components/missing-indicator';
import SiteLogo from 'soapbox/components/site-logo';
import Status from 'soapbox/components/status';
import { Spinner } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import { iframeId } from 'soapbox/iframe';
import { makeGetStatus } from 'soapbox/selectors';

/** Status to be presented in an iframe for embeds on external websites. */
const EmbeddedStatus = _ref => {
  let {
    params
  } = _ref;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const getStatus = useCallback(makeGetStatus(), []);
  const status = useAppSelector(state => getStatus(state, {
    id: params.statusId
  }));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Prevent navigation for UX and security.
    // https://stackoverflow.com/a/71531211
    history.block();
    dispatch(fetchStatus(params.statusId)).then(() => setLoading(false)).catch(() => setLoading(false));
  }, []);
  useEffect(() => {
    window.parent.postMessage({
      type: 'setHeight',
      id: iframeId,
      height: document.getElementsByTagName('html')[0].scrollHeight
    }, '*');
  }, [status, loading]);
  const logo = /*#__PURE__*/React.createElement("div", {
    className: "flex align-middle justify-center ml-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SiteLogo, {
    className: "max-h-[20px] max-w-[112px]",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 7
    }
  }));

  const renderInner = () => {
    if (loading) {
      return /*#__PURE__*/React.createElement(Spinner, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 14
        }
      });
    } else if (status) {
      return /*#__PURE__*/React.createElement(Status, {
        status: status,
        accountAction: logo,
        variant: "default",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 14
        }
      });
    } else {
      return /*#__PURE__*/React.createElement(MissingIndicator, {
        nested: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59,
          columnNumber: 14
        }
      });
    }
  };

  return /*#__PURE__*/React.createElement("a", {
    className: "block bg-white dark:bg-primary-900",
    href: (status === null || status === void 0 ? void 0 : status.url) || '#',
    onClick: e => e.stopPropagation(),
    target: "_blank",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 sm:p-6 max-w-3xl pointer-events-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 7
    }
  }, renderInner()));
};

export default EmbeddedStatus;